module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving12-f04005bbddb94e8e992071fc04078eac.jpg";